import React from "react";
import Renderer from "../renderer";
import { useQuiz } from '../../pages/quiz/hooks';
import Typography from "@mui/material/Typography";
import { fontSize, fontWeight } from "@mui/system";

export default function GroupDetails ({group={}, style,}) {

    const {currentQuestionGroup, groupQuestionCount} = useQuiz();

    return (
        <div style={{...style, ...styles.container}}>
            <Typography color="primary.questionHead" variant="h5" sx={{mb: 2, fontWeight:'600'}}>
            {group.groupName}
            </Typography>


            <Renderer content={group.details.text} style={styles.renderer}
                mediaStyle={styles.rendererMedia}
                contentUrl={group.details.contentURL} 
                enableTextToAudio={group.details?.enableTextToAudio}
                contentType={group.details.style} 
                overrideHTML={group.details.overrideHTML}
                templateType={group.details.displayTemplate} />

            <div style={styles.questionCount}>
                Group question: {groupQuestionCount}/{currentQuestionGroup.noOfQuestions}
            </div>
        </div>
    )
}

const styles = {
    container: {
        position: 'relative'
    },
    renderer: {
        color: 'var(--mui-palette-text-primary)'
    },
    rendererMedia: {
        height: '250px',
        width: '100%',
        objectFit: 'cover'
    },
    questionCount: {
        textAlign: 'right',
        fontSize: '20px',
        color: 'var(--mui-palette-primary-orange)',
        position: 'absolute',
        right: '20px',
        top: '-40px',
        fontWeight: 'bold'
    }
}